
















































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import eventHub from "@/event-hub";

import attendeeVuexModule from "@/store/vuex-modules/attendees";
import layoutImagesVuexModule from "@/store/vuex-modules/layoutImages";

import AttendeePrimaryInterest from "@/components/attendees/AttendeePrimaryInterest.vue";
import NotFound from "@/views/NotFound.vue";
import AttendeeAvatarEditForm from "@/components/attendee-profile/AttendeeAvatarEditForm.vue";
import AttendeeProfileEditForm from "@/components/attendee-profile/AttendeeProfileEditForm.vue";
import Spinners from "@/components/utilities/Spinners.vue";
import svgLinkedin from "@/components/svg/svg-linkedin.vue";
import svgInstagram from "@/components/svg/svg-instagram.vue";
import svgFacebook from "@/components/svg/svg-facebook.vue";
import svgTwitter from "@/components/svg/svg-twitter.vue";
import svgYoutube from "@/components/svg/svg-youtube.vue";
import svgSnapchat from "@/components/svg/svg-snapchat.vue";

const layoutImagesStore = getModule(layoutImagesVuexModule);
const attendeeStore = getModule(attendeeVuexModule);

@Component({
    components: {
        Spinners,
        NotFound,
        AttendeeAvatarEditForm,
        AttendeeProfileEditForm,
        AttendeePrimaryInterest,
        svgLinkedin,
        svgInstagram,
        svgFacebook,
        svgTwitter,
        svgYoutube,
        svgSnapchat
    }
})
export default class AttendeeProfile extends Vue {
    @Prop(String)
    id!: string;

    isLoading = true;
    isAvatarModalOpen = false;
    isModalOpen = false;

    // Getters
    get sectionToUse() {
        return this.$store.getters.getPageOptions("attendees");
    }
    get layoutImageAttendee() {
        return layoutImagesStore.getLayoutImage("attendee");
    }

    get awsConfig() {
        return this.$store.getters.awsConfig;
    }
    get isDemoData() {
        return !this.awsConfig.attendeeTable;
    }
    get attendeeData() {
        return attendeeStore.attendee;
    }
    get attendeeAvatarImage() {
        return attendeeStore.avatarImage;
    }
    get attendeeAvatarFileName() {
        return attendeeStore.avatarFileName;
    }
    get hasSocialMediaLinks() {
        return Boolean(
            this.attendeeData.linkedIn ||
                this.attendeeData.instagram ||
                this.attendeeData.facebook ||
                this.attendeeData.twitter ||
                this.attendeeData.snapchat ||
                this.attendeeData.youTube
        );
    }

    get avatarUrl() {
        if (!this.attendeeData) return "";

        if (attendeeStore.attendeeAvatarUrl) {
            return attendeeStore.attendeeAvatarUrl;
        } else if (this.isDemoData)
            return `https://vmpstore.s3.amazonaws.com/images/attendees/${this.attendeeData.imgPath}`;
        else {
            return this.attendeeData.imgPath
                ? this.attendeeData.imgPath
                : require("../../assets/avatar2.png");
        }
    }

    get thisIsMyProfile() {
        const user = this.$store.getters.user;
        return Boolean(user.id === this.attendeeData.attendeeId);
    }

    get attendeeApiOptions() {
        const options = { id: this.id, isDemoData: false };
        return options;
    }

    get attendeeFirstAndLast() {
        return `${this.attendeeData.firstName} ${this.attendeeData.lastName}`;
    }

    // lifecycle
    created() {
        const attendeePromises = [
            this.fetchAttendeeAvatar(),
            this.fetchAttendee()
        ];
        Promise.all(attendeePromises).finally(() => {
            this.isLoading = false;
        });
    }

    //methods
    fetchAttendee() {
        return attendeeStore.getAttendee(this.attendeeApiOptions);
    }

    fetchAttendeeAvatar() {
        return attendeeStore.getAttendeeAvatarUrl(this.attendeeApiOptions);
    }

    showModal() {
        this.isModalOpen = true;
    }

    closeModal() {
        this.isModalOpen = false;
    }

    showAvatarModal() {
        this.isAvatarModalOpen = true;
    }

    closeAvatarModal() {
        this.isAvatarModalOpen = false;
    }

    startFileUpload() {
        this.isLoading = true;

        eventHub.$emit("attendee-avatar-upload-started");

        this.handleFileUpload()
            .then(() => {
                eventHub.$emit("attendee-avatar-upload-success");
            })
            .catch(() => {
                eventHub.$emit("attendee-avatar-upload-error");
            })
            .finally(() => {
                eventHub.$emit("attendee-avatar-upload-done");
                this.isLoading = false;
            });
    }

    async handleFileUpload() {
        const options = {
            ...this.attendeeApiOptions,
            image: this.attendeeAvatarImage
        };

        try {
            await attendeeStore.uploadAttendeeAvatar(options);
        } catch (error) {
            throw new Error("Upload failed.");
        }

        try {
            await this.fetchAttendeeAvatar();
        } catch (error) {
            throw new Error("Get avatar failed.");
        }
    }

    handleProfileEditSubmit() {
        this.isLoading = true;
        eventHub.$emit("attendee-update-started");
        attendeeStore
            .putAttendee(this.attendeeApiOptions)
            .then(() => {
                eventHub.$emit("attendee-update-success");
            })
            .catch(() => {
                eventHub.$emit("attendee-update-error");
            })
            .finally(() => {
                eventHub.$emit("attendee-update-done");
                this.isLoading = false;
            });
    }

    openMessage() {
        this.$router.push({
            name: "Message-Center",
            params: {
                id: this.$props.id,
                name: `${this.attendeeData.firstName} ${this.attendeeData.lastName}`,
                companyName: this.attendeeData.companyName
                    ? this.attendeeData.companyName
                    : ""
            }
        });
    }

    // MOCK DATA
    // associate with attendee data based on the key
    // key matches values in attendeedata interface, azure collection etc.
    // primaryInterests = [
    //     {
    //         imgPath: require("../../assets/images/networking-icon.png"),
    //         title: "Networking",
    //         id: 1,
    //         key: "lookingNetwork"
    //     },
    //     {
    //         imgPath: require("../../assets/images/collaboration-icon.png"),
    //         id: 2,
    //         title: "Collaboration",
    //         key: "lookingCollab"
    //     },
    //     // {
    //     // 	imgPath: require('../../assets/images/hiring-icon.png'),
    //     // 	id: 3,
    //     // 	title: 'Hiring',
    //     // 	key: 'lookingHiring',
    //     // },
    //     {
    //         imgPath: require("../../assets/images/technology-icon.png"),
    //         id: 4,
    //         title: "Technology",
    //         key: "lookingTech"
    //     }
    //     // {
    //     // 	imgPath: require('../../assets/images/research-icon.png'),
    //     // 	id: 5,
    //     // 	title: 'Research',
    //     // 	key: 'lookingResearch',
    //     // },
    // ];

    // favoriteMockData = [
    //     {
    //         imgPath: require("../../assets/images/img-profile-2.png"),
    //         desc:
    //             "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla leo odio, malesuada a purus id."
    //     },
    //     {
    //         imgPath: require("../../assets/images/img-profile-2.png"),
    //         desc:
    //             "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla leo odio, malesuada a purus id."
    //     },
    //     {
    //         imgPath: require("../../assets/images/img-profile-2.png"),
    //         desc:
    //             "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla leo odio, malesuada a purus id."
    //     },
    //     {
    //         imgPath: require("../../assets/images/img-profile-2.png"),
    //         desc:
    //             "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla leo odio, malesuada a purus id."
    //     }
    // ];

    // companyProfileMockData = [
    //     {
    //         imgPath: require("../../assets/images/acme-logo.png"),
    //         companyName: "ACME Incorporated",
    //         desc:
    //             "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla leo odio, malesuada a purus id, sodales fringilla eros. In quam sapien, laoreet non tempus finibus, accumsan vel turpis. Sed at sem tempor, cursus turpis non, rutrum purus. Sed ac mi eleifend, tincidunt erat nec, ultrices turpis. Donec purus lectus, aliquam non tincidunt a, pellentesque sagittis ante. Maecenas pretium urna sed magna tempor, non eleifend enim ornare. Pellentesque tempor a tortor nec gravida. Mauris nibh nibh, rutrum et vulputate a, euismod id urna. In sem tellus, porta non lacus convallis.",
    //         id: 1
    //     }
    // ];
}
